export default __webpack_public_path__ + "28db367efa8d97700e8ded73b0a18921.png";